const LpaType = {
  None: 0,
  NmolL: 1,
  MgDl: 2
};

export default LpaType;